import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BookingService } from 'app/modules/bookings/services/booking.service';
import { ConfirmationService, Message } from 'primeng/api';
import { AppSettings } from '../../app.settings';
import { ThirdPartyScreenFilterModel } from '../../save-filter-models/third-party-screen-filter-model';
import { ThirdPartyScreenFiltersDataModel } from '../../save-filter-models/third-party-screen-filters-data-model';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { StorageService } from '../../services/storage.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';
import { MiGrid2Component } from '../mi-grid-2/mi-grid-2.component';

@Component({
  selector: 'app-shared-third-party-transfer',
  templateUrl: './shared-third-party-transfer.component.html',
  styleUrls: ['./shared-third-party-transfer.component.scss']
})
export class SharedThirdPartyTransferComponent implements OnInit, OnDestroy {

  gridTheme = 'mi';
  showSerialNo = false;
  url = '';
  tempUrl = '/secure/tour/list/data?type=ACTIVE&subServiceType=THIRD_PARTY';
  gridColumn: any;
  assignHeader;
  message: Message[] = [];
  columns: any = [];
  params: any = '';
  exportUrl = '';
  printUrl = '';
  statusListToChange = [];
  statusListFilterOptions = [];
  recordCount = 0;
  bookingCancelsPopup = false;
  selectParkingLocationHeader;
  yearRange = AppSettings.YEAR_RANGE_SELECTION;
  textToprint = '';
  hasShowDriverSideBar = false;
  bookingDetails;
  dateRange;
  minDate: Date = null;
  maxDate: Date = new Date();
  uniqId = AppSettings.UNIQID.SHARED_THIRD_TRANSF_8067;
  fromDate = null;
  toDate = null;
  fromDateMilliSeconds: any = '';
  toDateMilliSeconds: any = '';
  dispatchLocations: any = [];
  dispatchPostData: any = {};
  selectedBookingId;
  locationCategoryId;
  selectedLocationId;
  msgs: Message[] = [];
  driverList = [];
  companyOptions = [];
  searchPlaceHolder;
  dateRangePlaceHolder;
  pickupDropPlaceHolder;
  assignDriverPopUpShow = false;
  pickupLocationsOptions: any[] = [];
  dropLocationsOptions: any[] = [];
  serviceCitiesOptions: any[];
  passengerTypeOptions: any[];
  selectedPickupLocation;
  selectedDropLocation;
  selectedPassengerType;
  selectedBookingStatus = [];
  selectedDispatchAddress;
  selectedJourneyType;
  _broadSub
  paginationCount = AppSettings.BOOKING_DEFAULT_PAGINATION;
  journeyTypeOptions;
  sortTypeOptions = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS;
  selectedSortType: String = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
  changeBookingStatusAllow: Boolean = true;
  collapsed = false;
  originalFilterData: any;
  eventIdParam;
  changedFilterData: any;
  filterApplied = false;
  gridScrollHeight = '';

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;
  currentRoute: string;
  constructor(
    private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private confirmationService: ConfirmationService,
    private uiService: UiService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private bookingService: BookingService
  ) {
    this.changeBookingStatusAllow = this.commonBindingDataService.hasLogicalAccessPresent('UPDATE_JOURNEY_STATUS', 'CURRENT_BOOKINGS');
    this.initializeUrl();
    this.statusListToChange = AppSettings.THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS; //AppSettings.BOOKING_STATUS_CODES_OPTIONS;
    this.statusListFilterOptions = AppSettings.BOOKING_STATUS_CODES_FILTER_OPTIONS;
    this.columns.push({
      field: 'pickupDateTimeStr', width: 110, header: this.commonBindingDataService.getLabel('grid_pickup_time'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
    });
    this.columns.push({
      field: 'pFirstName', width: 150, header: this.commonBindingDataService.getLabel('grid_passenger'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getPassengerName(i)),
    });
    this.columns.push({
      field: 'appBooking', width: 100, header: this.commonBindingDataService.getLabel('label_booking_source'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingSource(i)),
    });
    this.columns.push({
      field: 'pickupLocationName', width: 200, header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
    });
    this.columns.push({
      field: 'vehicle Type', width: '10%', header: this.commonBindingDataService.getLabel('label_requested_vehicle_type'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getvehicle(i)),
    });
    // this.columns.push({
    //   field: 'Info', width: 100, header: this.commonBindingDataService.getLabel('grid_info'),
    //   sort: false, resize: true, cellRendererHtml: (i) => (this.getInfo(i)),
    // });
    this.columns.push({
      field: 'bookingStatus', header: this.commonBindingDataService.getLabel('grid_status'),
      sort: false, resize: true, isDropDown: true, options: this.statusListToChange,
      dropdownCount: 1, width: 200, disabled: !this.changeBookingStatusAllow, borderClass: 'border-class'
    });

    if (this.commonBindingDataService.hasLogicalAccessPresent('ASSIGN_DRIVER_TO_JOURNEY', 'CURRENT_BOOKINGS')) {
      this.columns.push({
        field: '', header: this.commonBindingDataService.getLabel('label_action'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.actionCells(i)), width: '100px'
      });
    }

  }

  initializeUrl() {
    // const filterData: ThirdPartyScreenFilterModel =
    //   this.userCommonService.getSavedFilters(AppSettings.FILTER_SCREEN_CODE.THIRD_PARTY_TRANSFER_SCREEN);
    let filterData = this.gateAllFilters();
    if (filterData) {
      const localData = filterData.filterData;
      this.collapsed = (localData.opencloseFilter) ? ((localData.opencloseFilter.toString() === 'true') ? true : false) : false;
      this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
      this.selectedPickupLocation = localData.selectedPickupLocation ? localData.selectedPickupLocation : '';
      this.selectedDropLocation = localData.selectedDropLocation ? localData.selectedDropLocation : '';
      this.selectedPassengerType = localData.selectedPassengerType ? localData.selectedPassengerType : '';
      this.selectedDispatchAddress = localData.selectedDispatchAddress ? localData.selectedDispatchAddress : '';
      this.selectedJourneyType = localData.selectedJourneyType ? localData.selectedJourneyType : '';
      this.selectedSortType = localData.selectedSortType ? localData.selectedSortType : this.selectedSortType;
      this.selectedBookingStatus = localData.selectedBookingStatus ? JSON.parse('[' + localData.selectedBookingStatus + ']') : [];

      this.fromDateMilliSeconds = localData.fromDateMilliSeconds ? localData.fromDateMilliSeconds : '';
      this.toDateMilliSeconds = localData.toDateMilliSeconds ? localData.toDateMilliSeconds : '';
      this.fromDate = localData.fromDateMilliSeconds ? new Date(+localData.fromDateMilliSeconds) : null;
      this.toDate = localData.toDateMilliSeconds ? new Date(+localData.toDateMilliSeconds) : null;

      this.url = `${this.tempUrl}&pickupAddressId=${this.selectedPickupLocation}&dropAddressId=${this.selectedDropLocation}` +
        `&passengerTypeId=${this.selectedPassengerType}&serviceAreaId=${this.selectedDispatchAddress}` +
        `&statusId=${this.selectedBookingStatus}&journeyTypeCode=${this.selectedJourneyType}` +
        `&fromDate=${this.fromDateMilliSeconds}&toDate=${this.toDateMilliSeconds}&sortBy=${this.selectedSortType}`;
    } else {
      this.url = this.tempUrl + `&sortBy=${this.selectedSortType}`;
    }
    this.gateAndSetAllFilters();
  }

  ngOnInit() {
    this.currentRoute = this.router.url.split('/')[2]
    this.commonBindingDataService.bookingTabCountChange.next(true);
    this.prepareJourneyTypeOptions();
    this.getPickupAddress();
    this.getPassengerTypeList();
    this.getServiceCityList();
    this.selectParkingLocationHeader = this.commonBindingDataService.getLabel('label_select_parking_location');
    // if (this.commonBindingDataService.hasLogicalAccessPresent('BOOKINGS_EXPORT_IN_EXCEL', 'CURRENT_BOOKINGS')) {
    //   this.exportUrl = '/secure/booking/list/data/export/xls';
    // }
    if (this.commonBindingDataService.hasLogicalAccessPresent('CURRENT_BOOKING_EXPORT_CURRENT_BOOKINGS_EXCEL', 'CURRENT_BOOKINGS')) {
      this.exportUrl = '/secure/tour/list/data/export/xls';
    }

    if (this.commonBindingDataService.hasLogicalAccessPresent('BOOKINGS_EXPORT_IN_PDF', 'CURRENT_BOOKINGS')) {
      this.printUrl = '/secure/booking/list/data/export/pdf';
    }
    this._broadSub = this.commonBindingDataService.bookingGridRefresh.subscribe((result) => {
      if (result === AppSettings.SUB_BOOKINMG_SERVICE_TYPES_LIST.THIRDPARTY) {
        this.gridRef2.refreshList();
      }
    });

    const storedEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    if (storedEventId) {
      this.eventIdParam = storedEventId;
    }

    if (!this.eventIdParam) {
      let tempEventId = this.commonBindingDataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
      }
    }

    if (this.eventIdParam) {
      this.prepareJourneyTypeOptions();
      this.getPickupAddress();
      this.getPassengerTypeList();
      this.getServiceCityList();
    }

    this.commonBindingDataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.prepareJourneyTypeOptions();
      this.getPickupAddress();
      this.getPassengerTypeList();
      this.getServiceCityList();
    });
    this.companyOptions = [
      {
        label: this.commonBindingDataService.getLabel('label_all'),
        value: ''
      }];
    this.searchPlaceHolder = this.commonBindingDataService.getLabel('label_search_by_passenger_barcode_journey_id');
    this.dateRangePlaceHolder = this.commonBindingDataService.getLabel('label_from_to_todate');
    this.pickupDropPlaceHolder = this.commonBindingDataService.getLabel('All');
  }

  prepareJourneyTypeOptions() {
    const firstPart = Object.assign([], AppSettings.JOURNEY_TYPES_TO_SHOW);
    const secondPart = Object.assign([], AppSettings.JOURNEY_TYPES_TO_SHOW);
    this.journeyTypeOptions = Object.assign([], AppSettings.JOURNEY_TYPES_TO_SHOW);
    const firstArray = firstPart.splice(0, 1);
    const secondArray = secondPart.splice(2, 2);
    this.journeyTypeOptions = [...firstArray, ...secondArray];
    this.journeyTypeOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
  }
  getRequestedVehicleType(params) {
    const eDiv = document.createElement('div');
    let requestedVT = `<div title="${params.vehicleType}" style="text-align:center;">${params.vehicleType}</div>`
    eDiv.innerHTML += requestedVT;
    return eDiv;
  }

  firstCell(params) {
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table" title="">
     <div class = "pickup-time">` + params.pickupTimeStr + `
     </div>
    <div class = "pickup-date">` + params.pickupDateStr + `</div>
    </div>`;
    eDiv.innerHTML += lblStatus;
    return eDiv;
  }

  getPassengerName(params) {

    const passengerType = (params.passengerType) ? params.passengerType : '--';
    const firstName = params.firstName ? params.firstName : '--'
    const lastName = params.lastName ? params.lastName : '--';
    const priority = params.passengerType ? `(${params.passengerType})` : '';
    const passengerCount = params.totalNoOfPassengers;

    const seatLetters = this.getChildLetters(params);

    const eDiv = document.createElement('div');
    let preparedData = '';
    if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.GENERAL ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.SPECIAL_EVENT) {
      preparedData = `<div class="booking-grid-table" title="">
      <div class = "passenger-name" title="${firstName} ${lastName} ${priority}">` + firstName + `&nbsp` + lastName + `&nbsp ${priority}</div>
      <div class = "pickup-date drop-adr pass-info passenger">${passengerCount} Pass <span class = "child-seat">${seatLetters ? seatLetters : ''}</span></div>
      </div>`;
    } else if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY && params.firstName) {
      preparedData = `<div class="booking-grid-table" title="">
      <div class = "passenger-name" title="${firstName} ${lastName} ${priority}">` + firstName + `&nbsp` + lastName + `&nbsp ${priority}</div>
      <div class = "pickup-date drop-adr pass-info passenger">${passengerCount} Pass <span class = "child-seat">${seatLetters ? seatLetters : ''}</span></div>
      </div>`;
    } else {
      let title = this.commonBindingDataService.getLabel('SHUTTLE');
      if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.VEHICLE_TRANSFER) {
        title = this.commonBindingDataService.getLabel('VEHICLE TRANSFER');
      }
      preparedData = `<div class="booking-grid-table" title="">
      <div class = "passenger-name">` + title + `</div>
      </div>`;
    }
    eDiv.innerHTML += preparedData;
    return eDiv;
  }

  getPickDropLocation(params) {
    params.BookingStatusPrevious = params.bookingStatus;
    const eDiv = document.createElement('div');
    const addressInstructions = this.prepareNote(params);
    const PreparedData = `
    <div style="margin-top: -13px;margin-bottom: -4px;">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div clas="col-12">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider"></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10 passenger-name">
        <div class="passenger-name" title="${params.pickupLocationName}">` + params.pickupLocationName + `</div>
        <div class="pickup-date drop-adr opa-9" title="${params.dropLocationName}">` + params.dropLocationName + `</div>
      </div>
    </div>` + ((params.tripNote || params.passengerNote || params.passengerStayAddressNote) ? `
    <div clas="col-12" style="margin-top: -5px;">
      <span class="address-instrn" title="${addressInstructions}"><img src="/assets/images/temp/info-icon.svg"></span>
    </div>` : '') +
      `</div></div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  prepareNote(params) {
    let totalNote = '';
    if (params.tripNote) {
      totalNote += `Booking note: ${params.tripNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerNote) {
      totalNote += `Passenger note: ${params.passengerNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerStayAddressNote) {
      totalNote += `Address note: ${params.passengerStayAddressNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    return totalNote;
  }

  getInfo(params) {
    const passengerCount = params.totalNoOfPassengers;
    params.BookingStatusPrevious = params.bookingStatus;
    const seatLetters = this.getChildLetters(params);
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="">
      <div class = "pickup-time">${passengerCount}<span class = "info-span">Pass</span></div>
      <div class = "pickup-date info-lower-div">${seatLetters}</div>
      </div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getvehicle(params) {
    const passengerCount = params.totalNoOfPassengers;
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="${params.vehicleType}">
    <div class = "pickup-time"><span>${params.vehicleType}</span></div>
    </div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getDriver(params) {
    const driverName = params.driverName ? params.driverName : '';
    const driverVehicleType = params.driverVehicleType ? params.driverVehicleType : '';
    const vehicleRegistration = params.vehicleRegistration ? params.vehicleRegistration : '';

    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table gid" title="">
    <div class = "passenger-name">${driverName}</div>
    <div class = "pickup-date drop-adr pass-info vehicle">${driverVehicleType}-${vehicleRegistration}</div>
    </div>`;
    let returnString = params.driverVehicleType ? PreparedData : 'NA'
    eDiv.innerHTML += returnString;
    return eDiv;
  }

  getChildLetters(params) {
    const childSeats = (params.totalNoOfChildseats) ? params.totalNoOfChildseats : 0;
    const babyseat = (params.totalNoOfBabyseats) ? params.totalNoOfBabyseats : 0;
    const wheelchair = (params.totalNoOfWheelchairs) ? params.totalNoOfWheelchairs : 0;
    let requiredString = '';
    for (let eachSeat = 0; eachSeat < wheelchair; eachSeat++) {
      requiredString += 'W';
    }
    for (let eachSeat = 0; eachSeat < babyseat; eachSeat++) {
      requiredString += 'B';
    }
    for (let eachSeat = 0; eachSeat < childSeats; eachSeat++) {
      requiredString += 'C';
    }
    return requiredString;
  }

  actionCells(params) {
    let assignType = 'assignDriver';
    let assignIcon = '/assets/images/temp/icon-assign-grid.svg';
    let isEnabled = this.checkIfReassignable(params, 'grey') === true;
    let isReassign = true;
    
    if (params.driverId) {
      assignType = 'reAssignDriver';
      assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
    } else {
      assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
    }

    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-btn-div buttons action-buttons-container');
    
    const disabledClass = isEnabled ? '' : ' disabled';
    const reassignClass = isReassign ? ' reassign-icon' : '';
    const hasNextButton = params.showMergeButton === true || params.showUnmergeButton === true;
    const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
    const tooltipText = isReassign ? 'Reassign' : 'Assign';
    const assignReassignBtn = `<div data-action-type=${assignType} class="grid-btn-div grid-action-icon-btn${disabledClass}${reassignClass}" style="${marginStyle}" title="${tooltipText}">
       <img src="${assignIcon}" alt="Assign" />
    </div>`;
    
    let mergeBtn = '';
    if (params.showMergeButton === true) {
      const hasNextButton = params.showUnmergeButton === true;
      const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
      mergeBtn = `<div data-action-type="mergeBooking" class="grid-btn-div grid-action-icon-btn" style="${marginStyle}" title="Merge">
         <img src="/assets/images/temp/merge-grid.svg" alt="Merge" />
      </div>`;
    }
    
    let unmergeBtn = '';
    if (params.showUnmergeButton === true) {
      unmergeBtn = `<div data-action-type="unmergeBooking" class="grid-btn-div grid-action-icon-btn" title="Unmerge">
         <img src="/assets/images/temp/unmerge-grid.svg" alt="Unmerge" />
      </div>`;
    }
    
    eDiv.innerHTML = assignReassignBtn + mergeBtn + unmergeBtn;
    
    const actionButtons = eDiv.querySelectorAll('[data-action-type]');
    actionButtons.forEach(button => {
      (button as HTMLElement).style.pointerEvents = 'auto';
      (button as HTMLElement).style.cursor = 'pointer';
      (button as HTMLElement).setAttribute('data-row-id', params.id);
      const actionType = button.getAttribute('data-action-type');
      const rowData = params;
      
      const handleActionClick = (event: Event) => {
        const mouseEvent = event as MouseEvent;
        mouseEvent.stopImmediatePropagation();
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        if (actionType) {
          this.handleActionDirectly(actionType, rowData);
        }
        return false;
      };
      
      button.addEventListener('click', handleActionClick, { capture: true, passive: false });
    });
    
    return eDiv;
  }

  reloadGrid() {
    setTimeout(() => {
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, 1000);
    this.gridRef2.updateUrl(this.tempUrl + this.params);
  }

  refreshGrid() {
    this.gridRef2.refreshList();
  }

  goToManualBookingPage() {
    this.router.navigate(['bookings/manual-booking']);
  }

  onclickFilterApply() {
    this.applyFilter();
  }

  applyFilter() {
    this.params = '';
    if (this.fromDate !== undefined && this.toDate !== null) {
      this.fromDateMilliSeconds = this.fromDate.getTime();
      this.toDateMilliSeconds = this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime());
      this.params += ('&fromDate=' + this.fromDate.getTime() + '&toDate='
        + this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime()));
    }
    if (this.selectedPickupLocation !== undefined && this.selectedPickupLocation !== null) {
      this.params += (`&pickupAddressId=${this.selectedPickupLocation}`);
    }
    if (this.selectedDropLocation !== undefined && this.selectedDropLocation !== null) {
      this.params += (`&dropAddressId=${this.selectedDropLocation}`);
    }
    if (this.selectedPassengerType !== undefined && this.selectedPassengerType !== null) {
      this.params += (`&passengerTypeId=${this.selectedPassengerType}`);
    }
    if (this.selectedDispatchAddress !== undefined && this.selectedDispatchAddress !== null) {
      this.params += (`&serviceAreaId=${this.selectedDispatchAddress}`);
    }
    if (this.selectedBookingStatus !== undefined && this.selectedBookingStatus !== null) {
      this.params += (`&statusId=${this.selectedBookingStatus}`);
    }
    if (this.selectedJourneyType !== undefined && this.selectedJourneyType !== null) {
      this.params += (`&journeyTypeCode=${this.selectedJourneyType}`);
    }
    if (this.selectedSortType !== undefined && this.selectedSortType !== null) {
      this.params += (`&sortBy=${this.selectedSortType}`);
    }
    this.reloadGrid();
    this.updateSaveFilter();
  }

  resetFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.fromDateMilliSeconds = '',
      this.toDateMilliSeconds = '',
      this.dateRange = null;
    this.selectedPickupLocation = null;
    this.selectedDropLocation = null;
    this.selectedPassengerType = null;
    this.selectedDispatchAddress = null;
    this.selectedJourneyType = null;
    this.selectedBookingStatus = [];
    this.selectedSortType = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
    this.params = '';
    this.minDate = null;
    this.maxDate = new Date();
    this.reloadGrid();
    this.updateSaveFilter();
  }

  updateSaveFilter() {
    const saveFilterModel = new ThirdPartyScreenFilterModel({
      screenCode: AppSettings.FILTER_SCREEN_CODE.THIRD_PARTY_TRANSFER_SCREEN,
      filterData: new ThirdPartyScreenFiltersDataModel({
        selectedPickupLocation: this.selectedPickupLocation,
        selectedDropLocation: this.selectedDropLocation,
        fromDateMilliSeconds: this.fromDateMilliSeconds,
        toDateMilliSeconds: this.toDateMilliSeconds,
        selectedPassengerType: this.selectedPassengerType,
        selectedDispatchAddress: this.selectedDispatchAddress,
        selectedBookingStatus: this.selectedBookingStatus.toString(),
        selectedJourneyType: this.selectedJourneyType,
        selectedSortType: this.selectedSortType,
        opencloseFilter: this.collapsed,
      }),
    });

    this.userCommonService.updateSavedFilter(saveFilterModel).subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result);
      setTimeout(() => {
        this.gateAndSetAllFilters();
      }, 100);
      this.filterApplied = false;
    }, (error) => {
    });
  }


  changeDispatchLocation(event) {
    if (this.commonBindingDataService.checkIsEditable(event.data.bookingStatus)) {
      this.dispatchLocations = [];
      this.selectedBookingId = event.data.id;
      this.selectedLocationId = event.data.locationId;
      if (this.userCommonService.userMetaData.locationCategorisList) {
        this.userCommonService.userMetaData.locationCategorisList.map(ele => {
          if (ele.id === AppSettings.LOCATION_TYPES.PARKING) {
            this.locationCategoryId = ele.id;
            this.commonBindingDataService.getDispatchQueueLocations('non-grid',
              this.locationCategoryId, this.selectedBookingId, 'true', this.eventIdParam).subscribe(result => {
                if (result) {
                  this.dispatchLocations = result;
                  this.cdr.detectChanges();
                }
              })
          }
        });
      }
      this.bookingCancelsPopup = true;
    }
  }

  onSelectDispatchLocation(locationInfo) {
    this.dispatchPostData = {
      'tourId': this.selectedBookingId,
      'locationId': locationInfo.id,
      'eta': locationInfo.eta,
      'distance': locationInfo.distance,
    }
    this.commonBindingDataService.setDispatchLocation(this.dispatchPostData).subscribe(result => {
      if (result) {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.refreshGrid();
        this.bookingCancelsPopup = false;
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    })
  }


  changeBookingStatus(event) {
    switch (event.value) {
      case AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED:
        this.statusChangeToAdminConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED:
        this.statusChangeToDriverConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM:
        this.statusChangeToAccept(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ON_THE_WAY:
        this.statusDriverOnTheWay(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ARRIVED:
        this.statusDriverArrived(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.ON_TRIP:
        this.statusOnTrip(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.EXPIRED:
        this.statusExpired(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.CANCELED:
        this.statusCanceled(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.COMPLETED:
        this.statusCompleted(event);
        break;
      default:
        break;
    }
  }

  statusChangeToAdminConfirmed(event) {
    const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED }
    this.commonBindingDataService.adminConfirmed(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToDriverConfirmed(event) {
    const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED }
    this.commonBindingDataService.driverFirstConfirmed(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToAccept(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.acknowledgeTrip(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      // this.THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS[3].disabled = true;
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverOnTheWay(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverOntheWay(event.data.id, data).subscribe(results => {
      this.refreshGrid();
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS); this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverArrived(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverArrived(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS); this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusOnTrip(event) {
    this.message = [];
    const tripStartData = {

      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    };
    this.commonBindingDataService.startTrip(tripStartData, event.data.id).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS); this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusCompleted(event) {
    if (event.data.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
      if (event.data.BookingStatusPrevious !== AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM) {
        this.uiService.showMessage(this.commonBindingDataService.getLabel('error_status_change_fail'),
          AppSettings.MESSAGE_TYPE.ERROR);
        this.refreshGrid();
        return;
      }
    }
    const chargeData = [];
    const data = {
      tourId: event.data.id,
      manualDistanceByAdmin: '',
      time: '',
      dropLocationName: '',
      endTripLatitude: event.sourceLatitude,
      endTripLongitude: event.sourceLongitude,
      inputTourAdditionalReasonList: chargeData,
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0
    };
    this.commonBindingDataService.dropTrip(data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusExpired(event) {
    this.refreshGrid();
  }

  cancelApi(id, data) {
    this.commonBindingDataService.cancelBooking(id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusCanceled(event) {
    if (event.data.requestLabelType === AppSettings.LUGGAGE_REQUEST || AppSettings.MULTIPLE_VEHICLE_REQUEST || AppSettings.MULTIPLE_VEHICLE_WITH_LUGGAGE_REQUEST) {
      this.confirmationService.confirm({
        message: event.data.messageToCancelAssociateBookings,
        accept: () => {
          const data = {
            cancellationReason: '',
            cancelBooking: event.data.id
          };
          this.cancelApi(event.data.id, data)
        }
      });
    } else if (event.data && event.data.mergedRide === true) {
      this.confirmationService.confirm({
        message: 'This is a merge booking, confirming the cancellation you can now merge additional booking',
        accept: () => {
          const data = {
            cancellationReason: '',
            tourIds: [event.data.id]
          };
          this.cancelApi(event.data.id, data);
        }
      });
     }
    this.refreshGrid();
  }

  getEta(event: any) {
    this.bookingCancelsPopup = true;
  }
  totalCount(event: any) {
    this.recordCount = event;
  }

  getActionTypeFromEvent(event: any): string | null {
    const target = event.target;
    if (!target) return null;
    
    let element: HTMLElement | null = target;
    while (element && element !== document.body) {
      const actionType = element.getAttribute('data-action-type');
      if (actionType) {
        return actionType;
      }
      element = element.parentElement;
    }
    
    if (event.composedPath) {
      const path = event.composedPath();
      for (const pathElement of path) {
        if (pathElement && pathElement.getAttribute) {
          const actionType = pathElement.getAttribute('data-action-type');
          if (actionType) {
            return actionType;
          }
        }
      }
    }
    
    return null;
  }

  handleActionDirectly(actionType: string, data: any) {
    switch (actionType) {
      case 'assignDriver':
        return this.checkIfReassignable(data);
      case 'assignDrivers':
        return this.navigateToBookingDetails(data);
      case 'mergeBooking':
        this.commonBindingDataService.openMergePopup(data);
        return true;
      case 'unmergeBooking':
        this.openUnmergePopup(data);
        return true;
      default:
        return undefined;
    }
  }

  private navigateToBookingDetails(data: any) {
    if (this.commonBindingDataService.hasLogicalAccessPresent('VIEW_JOURNEY_DETAILS', 'CURRENT_BOOKINGS')) {
      return this.router.navigate(['bookings/booking-details'], { queryParams: { id: data.id, navigateFrom: 'thirdParty', fromScreen: this.currentRoute } });
    }
    return false;
  }

  onRowClicked(e: any) {
    const actionType = this.getActionTypeFromEvent(e.originalEvent);
    if (actionType) {
      e.originalEvent.stopPropagation();
      e.originalEvent.preventDefault();
      const handled = this.handleActionDirectly(actionType, e.data);
      if (handled !== undefined) {
        return handled;
      }
    }
    return this.navigateToBookingDetails(e.data);
  }

  checkIfReassignable(data, background?) {
    if (data.bookingStatus === AppSettings.BOOKING_STATUS_CODES_OPTIONS[1].value ||
      data.bookingStatus === AppSettings.BOOKING_STATUS_CODES_OPTIONS[2].value ||
      data.bookingStatus === AppSettings.BOOKING_STATUS_CODES_OPTIONS[3].value) {
      if (background) {
        return true;
      } else {
        return this.openSideBar(data);
      }
    } else {
      return false;
    }
  }

  openSideBar(data) {
    this.getDriverList(data);
    this.bookingDetails = data;
  }

  getDriverList(data) {
    if (data && data.vehicleTypeId) {
      this.commonBindingDataService.getDrivers(data.vehicleTypeId, data.id).subscribe(
        (result) => {
          this.driverList = result;
          this.hasShowDriverSideBar = true;
        }, (error) => {
        });
    }
  }

  isPopCancel(event) {
    this.bookingCancelsPopup = false;
  }

  isPopSave(event) {
    this.bookingCancelsPopup = false;
  }

  selectedClass(params) {
    let returnClass = '';
    if (this.selectedLocationId === params.id) {
      returnClass = 'background-selected';
    }
    return returnClass;
  }

  sideBarHideFromShaired() {
    this.refreshGrid();
    this.hasShowDriverSideBar = false;
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  getPickupAddress() {
    const locationCatIdArray = [];
    if (this.userCommonService.userMetaData) {
      const locationCatIdsRecords = this.userCommonService.userMetaData.locationCategorisList.filter(
        cat => {
          return (cat.id === AppSettings.All_LOCATION_TYPES.QUEUE || cat.id === AppSettings.All_LOCATION_TYPES.OTHER_LOCATION ||
            cat.id === AppSettings.All_LOCATION_TYPES.STAY_LOCATION || cat.id === AppSettings.All_LOCATION_TYPES.PARKING)
        })
      locationCatIdsRecords.map(ele => { locationCatIdArray.push(ele.id) });
      const locationCatIds = locationCatIdArray.join();
      this.commonBindingDataService.getPassengerAllocatedLocationData(locationCatIds, this.eventIdParam).subscribe(
        (result) => {
          this.pickupLocationsOptions = result.data.map(ele => ({ label: ele.code, value: ele.id }));
          this.pickupLocationsOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
        }, (error) => {
        });
    }
  }

  getServiceCityList() {
    this.serviceCitiesOptions = [];
    this.commonBindingDataService.getCities(this.eventIdParam).subscribe(results => {
      this.serviceCitiesOptions = results.map(element => ({ label: element.cityAliasName, value: element.id }));
      this.serviceCitiesOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    }, (error) => {
    });
  }

  getPassengerTypeList() {
    this.passengerTypeOptions = [];
    this.commonBindingDataService.getPassengerType(this.eventIdParam).subscribe(results => {
      this.passengerTypeOptions = results.data.map(ele => ({ label: ele.passengerType, value: ele.passengerTypeId }));
      this.passengerTypeOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    }, (error) => {
    });
  }

  showThirdPartyPopUp() {
    this.assignDriverPopUpShow = true;
  }

  onThirdPartyCancel() {
    this.assignDriverPopUpShow = false;
  }

  onSelectDates(e, from) {
    if (from === 'fromDate') {
      this.minDate = this.fromDate;
      this.changeFilter('fromDateMilliSeconds', this.fromDate.getTime().toString());
    }
    if (from === 'toDate') {
      this.maxDate = this.toDate;
      let finalToTime = this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime());
      this.changeFilter('toDateMilliSeconds', finalToTime.toString());
    }
  }

  onAfterToggle(event?) {
    this.collapsed = event.collapsed;
    this.updateOpenCloseFilter();
    this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
  }

  updateOpenCloseFilter() {
    const saveFilterModel = {
      screenCode: AppSettings.FILTER_SCREEN_CODE.THIRD_PARTY_TRANSFER_SCREEN,
      filterData: {
        opencloseFilter: this.collapsed,
      },
    };

    this.userCommonService.updateFilterOpenClose(saveFilterModel, 'opencloseFilter').subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result, 'opencloseFilter', result.filterData.opencloseFilter);
    }, (error) => {
    });
  }

  // aplly btn  change color start
  gateAndSetAllFilters() {
    this.gateAllFilters();
    this.makeAllFilterToString();
  }

  gateAllFilters() {
    let filterData: ThirdPartyScreenFilterModel = this.userCommonService.getSavedFilters(AppSettings.FILTER_SCREEN_CODE.THIRD_PARTY_TRANSFER_SCREEN);
    if (filterData) {
      let localData = filterData.filterData;
      this.originalFilterData = localData;
      this.changedFilterData = { ...localData };
      return filterData;
    } else {
      setTimeout(() => {
        this.resetFilter();
      }, 100);
    }
  }

  makeAllFilterToString() {
    if (this.originalFilterData) {
      let keys = Object.keys(this.originalFilterData);
      for (let i = 0; i < keys.length; i++) {
        this.changedFilterData[keys[i]] = this.changedFilterData[keys[i]] ? this.changedFilterData[keys[i]] : '';
        this.originalFilterData[keys[i]] = this.originalFilterData[keys[i]] ? this.originalFilterData[keys[i]] : '';
      }
    }
  }

  changeFilter(key?, val?) {
    this.changedFilterData[key] = val.toString();
    let changedvalus = [];
    let keys = Object.keys(this.originalFilterData);
    for (let i = 0; i < keys.length; i++) {
      if (this.originalFilterData[keys[i]] !== this.changedFilterData[keys[i]]) {
        changedvalus.push(keys[i]);
      }
    }
    this.filterApplied = false;
    if (changedvalus.length > 0) {
      this.filterApplied = true;
    }
  }
  // aplly btn  change color end


  onMergeComplete(result: any) {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  onMergePopupClose() {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  ngOnDestroy() {
    if (this._broadSub) {
      this._broadSub.unsubscribe();
    }
  }

  openUnmergePopup(data) {
    this.confirmationService.confirm({
      message: 'This is a merge booking, confirming the unmerging you can now merge additional booking?',
      accept: () => {
        this.performUnmerge(data);
      }
    });
  }

  performUnmerge(data) {
    const unmergeData = {
      tourIdList: [data.id],
    };
    
    this.bookingService.unmergeBookings(this.eventIdParam, unmergeData).subscribe(
      (result) => {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.refreshGrid();
        this.commonBindingDataService.bookingTabCountChange.next(true);
      },
      (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        this.refreshGrid();
      }
    );
  }
}